import { render, staticRenderFns } from "./wordreading.vue?vue&type=template&id=4595d545&scoped=true"
import script from "./wordreading.vue?vue&type=script&lang=js"
export * from "./wordreading.vue?vue&type=script&lang=js"
import style0 from "./wordreading.vue?vue&type=style&index=0&id=4595d545&prod&lang=scss&scoped=true"
import style1 from "./wordreading.vue?vue&type=style&index=1&id=4595d545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595d545",
  null
  
)

export default component.exports